import type { SimpleRecord } from "@smartsuite/types";
import { Fields } from "../types/fields";
import type { FormConfig, FormConfigApplicationStructureItem, Member } from "../types/form";
import { addressFieldConfig } from "./fields/address/address.config";
import { assignToFieldConfig } from "./fields/assign-to/assign-to.config";
import { checklistFieldConfig } from "./fields/checklist/checklist.config";
import { colorPickerConfig } from "./fields/color-picker/color-picker.config";
import { currencyFieldConfig } from "./fields/currency/currency.config";
import { dateFieldConfig } from "./fields/date/date.config";
import { dateRangeFieldConfig } from "./fields/date-range/date-range.config";
import { dueDateFieldConfig } from "./fields/due-date/due-date.config";
import { durationFieldConfig } from "./fields/duration/duration.config";
import { emailFieldConfig } from "./fields/email/email.config";
import { fileFieldConfig } from "./fields/file/file.config";
import { fullNameFieldConfig } from "./fields/full-name/full-name.config";
import { ipAddressConfig } from "./fields/ip-address/ip-address.config";
import { linkFieldConfig } from "./fields/link/link.config";
import { linkedRecordFieldConfig } from "./fields/linked-record/linked-record.config";
import { lookupFieldConfig } from "./fields/lookup/lookup.config";
import { multipleSelectFieldConfig } from "./fields/multiple-select/multiple-select.config";
import { numberFieldConfig } from "./fields/number/number.config";
import { numberSlideFieldConfig } from "./fields/number-slider/number-slider.config";
import { percentFieldConfig } from "./fields/percent/percent.config";
import { percentCompleteFieldConfig } from "./fields/percent-complete/percent-complete.config";
import { phoneFieldConfig } from "./fields/phone/phone.config";
import { ratingFieldConfig } from "./fields/rating/rating.config";
import { recordTitleFieldConfig } from "./fields/record-title/record-title.config";
import { signatureFieldConfig } from "./fields/signature/signature.config";
import { singleSelectFieldConfig } from "./fields/single-select/single-select.config";
import { smartdocFieldConfig } from "./fields/smartdoc/smartdoc.config";
import { statusFieldConfig } from "./fields/status/status.config";
import { tagFieldConfig } from "./fields/tags/tags.config";
import { teamFieldConfig } from "./fields/team/team.config";
import { textFieldConfig } from "./fields/text/text.config";
import { textareaFieldConfig } from "./fields/textarea/textarea.config";
import { timeFieldConfig } from "./fields/time/time.config";
import { yesNoFieldConfig } from "./fields/yes-no/yes-no.config";
import type { FieldRegistryConfig } from "./types";

export const fieldRegistryMap: Record<Fields, FieldRegistryConfig<any>> = {
  [Fields.addressfield]: addressFieldConfig,
  [Fields.currencyfield]: currencyFieldConfig,
  [Fields.datefield]: dateFieldConfig,
  [Fields.emailfield]: emailFieldConfig,
  [Fields.filefield]: fileFieldConfig,
  [Fields.fullnamefield]: fullNameFieldConfig,
  [Fields.linkedrecordfield]: linkedRecordFieldConfig,
  [Fields.linkfield]: linkFieldConfig,
  [Fields.lookupfield]: lookupFieldConfig,
  [Fields.multipleselectfield]: multipleSelectFieldConfig,
  [Fields.numberfield]: numberFieldConfig,
  [Fields.numbersliderfield]: numberSlideFieldConfig,
  [Fields.percentcompletefield]: percentCompleteFieldConfig,
  [Fields.percentfield]: percentFieldConfig,
  [Fields.phonefield]: phoneFieldConfig,
  [Fields.ratingfield]: ratingFieldConfig,
  [Fields.recordtitlefield]: recordTitleFieldConfig,
  [Fields.signaturefield]: signatureFieldConfig,
  [Fields.singleselectfield]: singleSelectFieldConfig,
  [Fields.smartdocfield]: smartdocFieldConfig,
  [Fields.statusfield]: statusFieldConfig,
  [Fields.textareafield]: textareaFieldConfig,
  [Fields.textfield]: textFieldConfig,
  [Fields.timefield]: timeFieldConfig,
  [Fields.userfield]: assignToFieldConfig,
  [Fields.teamfield]: teamFieldConfig,
  [Fields.yesnofield]: yesNoFieldConfig,
  [Fields.durationfield]: durationFieldConfig,
  [Fields.ipaddressfield]: ipAddressConfig,
  [Fields.colorpickerfield]: colorPickerConfig,
  [Fields.tagsfield]: tagFieldConfig,
  [Fields.duedatefield]: dueDateFieldConfig,
  [Fields.checklistfield]: checklistFieldConfig,
  [Fields.daterangefield]: dateRangeFieldConfig,
};

export function getFieldRegistryConfig(field: Fields): FieldRegistryConfig<unknown> {
  return fieldRegistryMap[field];
}

export const normalizePrefillFieldValue = ({
  value,
  field,
  linkedRecords,
  members,
  config,
}: {
  value: string;
  field: FormConfigApplicationStructureItem;
  linkedRecords?: SimpleRecord[];
  members?: Member[];
  config?: FormConfig;
}): any => {
  const fieldConfig = fieldRegistryMap[field.field_type];
  if (!fieldConfig?.prefill) return "";

  return fieldConfig.prefill({ value, field, linkedRecords, members, config });
};
